import { useEffect, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { type SystemInfo, getSystemInfo } from '@doxyme/ui-foundation/hooks';

type UseBrowserReturnValue = {
  systemInfo: SystemInfo;
};

const hookInitValues = {
  systemInfo: getSystemInfo(),
};

export const useBrowserImpl = (): UseBrowserReturnValue => {
  const [state, setState] = useState<UseBrowserReturnValue>(hookInitValues);

  useEffect(() => {
    setState((actualState) => {
      return {
        ...actualState,
        systemInfo: getSystemInfo(),
      };
    });
  }, []);

  return state;
};

export const useBrowser = singletonHook<UseBrowserReturnValue>(
  hookInitValues,
  useBrowserImpl,
);
